import { render, staticRenderFns } from "./AdvanceSettingTab.vue?vue&type=template&id=574e52f1&scoped=true&"
import script from "./AdvanceSettingTab.vue?vue&type=script&lang=js&"
export * from "./AdvanceSettingTab.vue?vue&type=script&lang=js&"
import style0 from "./AdvanceSettingTab.vue?vue&type=style&index=0&id=574e52f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574e52f1",
  null
  
)

export default component.exports